var _g, _path, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMymemo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 53,
    viewBox: "0 0 50 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_161_778)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 8C15.6112 8 8 15.6112 8 25C8 34.3888 15.6112 42 25 42C25.1784 42 25.3562 41.9972 25.5332 41.9918C26.2457 43.5372 27.8086 44.6097 29.6219 44.6097C32.1072 44.6097 34.1219 42.595 34.1219 40.1097C34.1219 39.8629 34.1021 39.6208 34.0639 39.3848C38.8326 36.3737 42 31.0567 42 25C42 15.6112 34.3888 8 25 8Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7235 17.3218L25.817 17.3171C26.2906 17.3171 26.6801 17.677 26.7269 18.1382L26.7317 18.2317V23.9024H32.4024C32.8759 23.9024 33.2655 24.2624 33.3123 24.7236L33.317 24.8171C33.317 25.2906 32.9571 25.6802 32.4959 25.727L32.4024 25.7317H26.7317V31.4024C26.7317 31.876 26.3717 32.2655 25.9105 32.3124L25.817 32.3171C25.3434 32.3171 24.9539 31.9572 24.9071 31.496L24.9024 31.4024V25.7317H19.2317C18.7581 25.7317 18.3686 25.3718 18.3217 24.9106L18.317 24.8171C18.317 24.3435 18.6769 23.954 19.1381 23.9072L19.2317 23.9024H24.9024V18.2317C24.9024 17.7581 25.2623 17.3686 25.7235 17.3218L25.817 17.3171L25.7235 17.3218Z",
    fill: "#808080"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 47,
    r: 2,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_161_778",
    x: 0,
    y: 0,
    width: 50,
    height: 52.6097,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_161_778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_161_778",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMymemo);
export default __webpack_public_path__ + "static/media/mymemo.5aba430468c054ecb1478facb9d440bd.svg";
export { ForwardRef as ReactComponent };